module.exports = __webpack_public_path__ + "img/icon-16-drop-down (1).e9dc218d.svg";